<template>
    <va-edit-layout>
        <ImagingServicesFeeEvent-form
            :id="id"
            :title="title"
            :item="item"
        ></ImagingServicesFeeEvent-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
